import { render, staticRenderFns } from "./EditorContainer.vue?vue&type=template&id=4faec1e4&"
import script from "./EditorContainer.vue?vue&type=script&lang=js&"
export * from "./EditorContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports